import { Producer } from 'types/producer'
import { getCapacityState, isReserved as getIsReserved } from 'utils/producers'
import { store } from 'store/index'
import { ProducerStatus } from 'components/producer-card/types'
import { Language } from 'types/language'

/**
 * Returns the producer status
 *
 * @param {Producer} producer
 * @param {Language} locale
 * @returns {ProducerStatus | null}
 */
export const getStatus = (producer: Producer, locale: Language): ProducerStatus | null => {
  // Store
  const { inputs, flows } = store.getState().customer

  // Constants
  const capacityState = getCapacityState(producer, inputs.simulation, flows.simulation.didSimulation)
  const isReserved = getIsReserved(producer)

  // Check if the producer is reserved
  if (isReserved) {
    return ProducerStatus.RESERVED
  }

  // Check if the producer is sold out
  if (capacityState.soldOut) {
    return ProducerStatus.SOLD_OUT
  }

  // Check if the producer is almost sold out
  if (capacityState.almostSoldOut) {
    return ProducerStatus.ALMOST_SOLD_OUT
  }

  // Check if the producer is popular
  if (producer.isPopular[locale]) {
    return ProducerStatus.POPULAR
  }

  // Return null if no status is found
  return null
}
